<template>
  <div id="jiageshenheNew">
    <van-sticky>
      <van-nav-bar
        :title="title"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      >
      </van-nav-bar>
    </van-sticky>
    <!-- <van-pull-refresh v-model="isLoading"
                      success-text="刷新成功"
                      @refresh="onRefresh"> -->
    <!-- <div style="background-color: #ffff00;height:0.3rem"></div> -->
    <!-- <van-sticky offset-top="1.0558rem"> -->
    <div class="xinxi">
      <div style="margin-bottom: 0.3rem">
        <van-row>
          <van-col span="5">
            <div class="blue-box"></div>
            期号：
          </van-col>
          <van-col span="7" class="twoLine">
            {{ sjExeno }}
          </van-col>
          <!-- <van-col span="5">
            <div class="blue-box"></div>
            截止时间：
          </van-col> -->
          <!-- <van-col span="7" class="twoLine">
            {{ priceDate }} {{ lateReportTime }}
          </van-col> -->
        </van-row>
      </div>

      <div style="margin-bottom: 0.3rem">
        <van-row>
          <van-col span="5">
            <div class="blue-box"></div>
            审核状态：
          </van-col>
          <van-col span="7" :class="[
                    {
                      'table-red':
                        Number(stateId) == 0 ||
                        Number(stateId) == 1 ||
                        Number(stateId) === 95 ||
                        Number(stateId) === 99 ||
                        Number(stateId) === 90 ||
                        (stateName&&stateName.indexOf('退回') > -1)
                    },
                    {
                      'table-blue':
                        Number(stateId) == 11 ||
                        Number(stateId) == 21 ||
                        Number(stateId) == 31
                    },
                    { 'table-green':
                        Number(stateId) == 12 ||
                        Number(stateId) == 22 ||
                        Number(stateId) == 32
                    }
                  ]">
            {{stateName}}
          </van-col>
          <van-col span="5">
            <div class="blue-box"></div>
            上报状态：
          </van-col>
          <van-col span="7" :class="[
                    {
                      'table-red':
                        Number(gjstate) === 100 ||
                        Number(gjstate) === 130 ||
                        (gjstateName&&gjstateName.indexOf('退回') > -1) ||
                        (gjstateName&&gjstateName.indexOf('失败') > -1) ||
                        !gjstateName ||
                        (gjstateName&&gjstateName.indexOf('未上报') > -1)
                    },
                    {
                      'table-blue': Number(gjstate) == 110
                    },
                    { 'table-green': Number(gjstate) === 120 }
                  ]">
            {{gjstateName}}
          </van-col>
        </van-row>
      </div>

      <div style="margin-bottom: 0.3rem">
        <van-row>
          <van-col span="5">
            <div class="blue-box"></div>
            任务名称：
          </van-col>
          <van-col span="19" class="twoLine">{{ gjTaskName }}</van-col>
        </van-row>
      </div>

      <div style="margin-bottom: 0.3rem">
        <van-row>
          <van-col span="5">
            <div class="blue-box"></div>
            采集地点：
          </van-col>
          <van-col span="14" class="twoLine">
            <div class="selectDiv">
              <van-dropdown-menu
                class="select"
                active-color="#4494f3"
                :overlay="false"
              >
                <van-dropdown-item
                  v-model="StationCode"
                  :options="stationList"
                  @change="dataGrid"
                  @open="selectOpen"
                />
              </van-dropdown-menu>
            </div>
          </van-col>
          <van-col span="5" class="twoLine">
            <van-button type="primary" size="mini" @click="nextStation"
              >下一条</van-button
            >
          </van-col>
        </van-row>
      </div>
      <!-- <van-row>
          <van-col span="5">
            <div class="blue-box"></div>采集地点：
          </van-col>
          <van-col span="7" class="twoLine">{{stationName}}</van-col>
            <van-col span="5">
              <div class="blue-box"></div>任务名称：
            </van-col>
            <van-col span="7" class="twoLine">
              {{taskName}}
            </van-col>
         </van-row> -->
    </div>
    <!-- </van-sticky> -->
    <van-sticky offset-top="1.0558rem">
      <div class="boxTitle">
        <van-row type="flex" justify="center" align="center">
          <van-col span="2" align="center">序号</van-col>
          <van-col span="7" align="center">商品</van-col>
          <van-col span="8" align="center">本期价格</van-col>
          <van-col span="4" align="center">上期价格</van-col>
          <van-col span="3" align="center">环比%</van-col>
        </van-row>
      </div>
    </van-sticky>

    <div class="table">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="onLoad"
        style="padding-bottom: 1.2rem"
      >
        <div
          :class="[index % 2 == 0 ? 'even' : 'odd']"
          v-for="(item, index) in list"
          :key="index"
        >
          <van-row type="flex" justify="center" align="center">
            <van-col span="2" align="center">{{ index + 1 }}</van-col>
            <van-col
              span="7"
              :style="{
                color:
                  item.VarietyCodeNew == item.VarietyCode || item.isGoods == 1 ||
                  (item.ThisPrice == 0 && item.ThisPrice != '') || (item.hbzks !== null&& item.hbNum > item.hbzks && item.hbNum > 0) || (item.hbjks !== null && Math.abs(item.hbNum) > item.hbjks && item.hbNum < 0)
                    ? 'red'
                    : 'blue',
              }"
              class="contentLimit"
              @click="clickStoreName(item, index)"
              >{{ item.VarietyName }}--{{ item.StandardName }}--{{
                item.TargetName
              }}</van-col
            >
            <van-col span="1" align="center">&emsp;</van-col>
            <van-col span="8">
              <div class="input">
                <input
                  v-model="item.ThisPrice"
                  :class="{ bianhui: saveState || item.isGoods == 1}"
                  @blur="changePrice(index)"
                  type="number"
                  :style="{
                    background:
                      (item.ThisPrice == 0 && item.ThisPrice != '') || saveState
                        ? '#efe7e7'
                        : '',
                  }"
                  oninput="if(value<0)value=0; if(value>99999999)value=99999999"
                  min="0"
                  max="99999999"
                  required
                />
              </div>
              {{ item.UnitName }}
            </van-col>
            <van-col span="2" align="right">{{ item.ringPrice }}</van-col>
            <!-- 环比：（本期数-上期数）/上期数×100% -->
            <van-col
              span="3"
              align="right"
              :style="{ color: item.styleColor }"
              v-model="item.hbNum"
              >{{ item.hbNum }}</van-col
            >
            <van-col span="1" align="right">&emsp;</van-col>
          </van-row>
        </div>
      </van-list>
    </div>
    <div class="bottom">
      <div style="display:flex;box-shadow: 0px -1px 10px #0000004d;height: 100%;align-items: center;">
        <div :class="{ bianhui: reportState }" offset="1" style="text-align: center;flex: 1;position: relative;">
          <v-button class="btn1" @click="report">上报</v-button>
        </div>
        <div  offset="1" style="text-align: center;flex: 1;position: relative;">
          <v-button class="btn1 btn2" @click="chaKanRiZhi">查看日志</v-button>
        </div>
      </div>

      <!-- <van-row type="flex" justify="center" align="center">
        <van-col span="4" :class="{ bianhui: reportState }">
          <v-button class="btn" @click="report">上报</v-button>
        </van-col>
        <van-col span="4" offset="1">
          <v-button class="btn" @click="chaKanRiZhi">查看日志</v-button>
        </van-col>
      </van-row> -->
    </div>
    <!-- </van-pull-refresh> -->
    <van-popup v-model="showDetial" :style="{ width: '75%' }">
      <van-field v-model="shopIndex1" label="序号" disabled />
      <van-field
        v-model="shopName"
        label="商品"
        rows="1"
        autosize
        type="textarea"
        disabled
      />
      <div style="display: flex;border-bottom: 1px solid  #ebedf0;margin-left: 0.2rem;">
        <div class="goodIs">无此品种</div>
        <van-checkbox v-model="isGoods" shape="square" @change="changeIsGoods" :disabled="saveState"></van-checkbox>
      </div>
      <van-field
        v-model="bqPrice"
        label="本期"
        :formatter="formatter"
        type="number"
        :disabled="isGoods || saveState"
        class="g_disabled"
      />
      <van-field
        v-if="ifShow == 1"
        v-model="brand"
        rows="2"
        label="品牌"
        type="text"
        maxlength="50"
        disabled
      />
      <van-field v-if="originBrandShow&& !isGoods" v-model="originBrand"
                 label="品牌产地"
                 class="long-label"
                 type="text"
                 maxlength="50"/>
      <van-field v-if="itemNumbersShow&& !isGoods" v-model="itemNumbers"
                 label="数量"
                 type="text"/>
      <van-field
        v-model="content"
        rows="3"
        autosize
        label="波动原因说明"
        type="textarea"
        class="long-txt g_disabled"
        maxlength="50"
        :disabled="saveState"
        minlength="2"
        show-word-limit
      />
      <!-- <van-field
        v-model="comments"
        rows="3"
        autosize
        label="备注"
        type="textarea"
        maxlength="50"
        show-word-limit
      /> -->
      <van-row type="flex" justify="center" align="center">
        <van-col span="6">
          <v-button class="btn" @click="closeBasic()">取消</v-button>
        </van-col>
        <!-- <van-col span="6" offset="4">
          <v-button
            class="btn"
            :class="{ bianhui: saveState }"
            @click="saveBasic()"
            >保存</v-button
          >
        </van-col> -->
      </van-row>
    </van-popup>
    <!-- 商品说明弹窗end -->
    <!-- 查看日志弹窗start -->
    <van-popup
      v-model="showLog"
      position="bottom"
      :style="{ height: '60%', backgroundColor: '#f0f2f1' }"
      id="logList"
    >
      <van-sticky>
        <div class="boxTitle">
          <van-row type="flex" justify="center" align="center">
            <van-col span="24" align="center">日志详情</van-col>
          </van-row>
        </div>
      </van-sticky>
      <div class="logTable" style="height: calc(100% - 1rem); overflow-y: auto">
        <div class="no-con" v-if="logList.length == 0">暂无数据</div>
        <div class="logBox" v-for="(item, index) in logList" :key="index">
          <van-row type="flex" justify="center" align="center">
            <van-col span="10">{{ item.editUser }}</van-col>
            <van-col span="10">{{ item.editTime }}</van-col>
          </van-row>
          <van-row type="flex" justify="center" align="center">
            <van-col span="20">{{ item.recordType }}</van-col>
          </van-row>
          <van-row type="flex" justify="center" align="center">
            <van-col span="20">{{ item.detailInfo }}</van-col>
          </van-row>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { loading } from "@/common/loading";
import {
  getJgjcReportExamStation,
  dataGrid,
  getDateRecord, //查看日志
  reportUpOk,
  checkLogin, //检查登陆状态
} from "@/api/baseMsg";
import { Toast } from "vant";
export default {
  name: "jiageshenheNew",
  data() {
    return {
      title: "国家上报详情",
      isLoading: false,
      list: [],
      loading: false,
      finished: false,
      periodNumber:this.$route.query.periodNumber,
      taskId:this.$route.query.taskId,
      periodSJNumber:this.$route.query.periodSJNumber,
      sjExeno:this.$route.query.sjExeno,
      sjtaskCode:this.$route.query.sjtaskCode,
      sjtaskName: this.$route.query.sjtaskName,
      gjTaskName: this.$route.query.gjTaskName,
      gjStationName:'',
      gjstate:'',
      dayTaskId:'',
      gjstateName:'',
      stateName:'',

      code: this.$route.query.code,
      taskCode: this.$route.query.taskCode,
      exeno: this.$route.query.exeno,
      ExeNo: this.$route.query.ExeNo,
      // StationCode: this.$route.query.StationCode,

      StationCode:'',
      RegionCode: this.$route.query.RegionCode,
      //   userCompName: this.$route.query.userCompName,
      taskID: this.$route.query.taskId,
      //   stationName: this.$route.query.stationName,
      tempCode: this.$route.query.tempCode,
      shopId: this.$route.query.shopId,
      shispflag: this.$route.query.shispflag, //市审核
      shengspflag: this.$route.query.shengspflag, //市审核 //1蓝2绿3灰
      ythflag: this.$route.query.ythflag,
      active: Number(this.$route.query.active), //日报周报选中状态
      active2: this.$route.query.active2, //当日任务 全部任务
      levelNum: this.$route.query.levelNum, //用户等级 2是市级 3是省级
      priceDate: this.$route.query.priceDate,
      lateReportTime: this.$route.query.lateReportTime,
      stateId: this.$route.query.stateId, //事项状态id
      dis: false, //
      shState: false, //审核状态
      cxState: true, //撤销审核状态
      backState: false, //退回状态
      saveState: false, //保存状态
      cxShiState: false, //市审核的时候没有撤销审核
      //
      showDetial: false, //展示商品说明
      shopIndex: "",
      shopName: "", //商品名称
      bqPrice: "", //本期价格
      bqPriceSave:'',
      contentSave:"",
      isGoods:"", //无此品种  1无，0有
      brand: "", //品牌
      ifShow: "", //为0的时候不显示 品牌文本框,1显示
      content: "", //说明
      comments: "", //备注
      originBrand:'',//品牌产地
      originBrandShow:false,
      itemNumbersShow:false,
      itemNumbers:'',//数量
      shopIndex1: "",
      ids: [], //数据
      //退回原因
      backInfo: "",
      showBackInfo: false,
      //查看日志
      showLog: false, //展示日志列表
      logList: [], //日志列表
      showLogDetial: false, //展示日志详情
      //
      todayCardList: [], //当日审核任务
      nextIndex: 0, //点击下一次下标
      //
      id: this.$route.query.id, //采价周期id
      //
      loginStatus: true,

      taskName: "", //任务名称
      stationName: "", //监测点
      editType: "1", //2是
      stationList: [], //监测点
      isOpen: false,
      titleShow: "审核通过",
      thCityState: false, //区县审核审核的时候没有退回
      //  listFlag:false, //判断是否修改了数据
      oldList: [], //存放原始数据数组

      reportState:false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    onRefresh() {
      //瀑布流刷新函数
      setTimeout(() => {
        this.isLoading = false;
        this.init();
      }, 300);
    },
    init() {
      this.checkLogin();
      if (this.loginStatus) {
        this.getStationList();
      }
    },
    getStationList() {
      getJgjcReportExamStation({
        exeno: this.periodSJNumber?this.periodSJNumber:this.sjExeno,
        pageIndex: 1,
        pageSize: 1000,
        taskCode: this.sjtaskCode,
        state:'',
        nationExeno:this.periodNumber
      }).then((res) => {
        if(res.data.list.length == 0) {
          Toast.fail('该任务无可上报监测点！')
          return
        }
        res.data.list.forEach((i,j)=> {
          i.value = i.stationCode + j
          i.text = i.gjStationName
        })
        this.stationList = res.data.list;
        this.StationCode = res.data.list[0].stationCode + 0;
        this.shopId = res.data.list[0].shopId;
        this.stateId = res.data.list[0].stateId

        this.gjstate = res.data.list[0].gjstate
        this.gjstateName = res.data.list[0].gjstateName
        this.stateName = res.data.list[0].stateName
        this.stateId = res.data.list[0].stateId
        this.dayTaskId = res.data.list[0].dayTaskId
        this.exeNo = res.data.list[0].exeNo
        this.taskCode = res.data.list[0].taskCode
        this.dataGrid();
      });
    },
    selectOpen() {
      // 判断是否打开了下拉框
      this.isOpen = true;
    },
    isTruelevelNum(levelNum, ext) {
      ext = ext + ""

      //判断底部按钮的状态
      //未填报0,未提交1,县市区已退回89,市级已退回90,省级已退回99
      if (levelNum == 1  || (levelNum == 2 && ["0", "1"].indexOf(ext)> -1)) {
        //区县账户
        this.titleShow = "上报";
        this.thCityState = true; //区县没有退回
        this.cxShiState = true; //区县没有撤销审核
        return ["0", "1"].indexOf(ext) == -1;
      } else if (levelNum == 2) {
        //设区市待审核 21
        this.cxShiState = true; //市没有撤销审核
        return ["0", "1", "21"].indexOf(ext) == -1;
      } else {
        //省级待审核 31 省级已审核32
        if(ext=='31'){
            this.cxState = true; //撤销审核状态
        }
        return ["0", "1", "31"].indexOf(ext) == -1;
      }
    },
    //houcc 2021.04.07
    dataGrid(value) {
      if (value == undefined) {
        value = this.StationCode;
      }
      if (this.isOpen) {
        const dir = this.stationList.find((item) => item.value === value);
        this.stateId = dir.stateId;
        this.shopId = dir.shopId;
        this.gjstate = dir.gjstate
        this.gjstateName = dir.gjstateName
        this.stateName = dir.stateName
        this.stateId = dir.stateId
        this.dayTaskId = dir.dayTaskId
        this.exeNo = dir.exeNo
        this.taskCode = dir.taskCode
      }
      this.isOpen = false;
      loading(true);
      if(!this.gjstateName || this.gjstate == 130) {
        this.reportState = false
      }else {
        this.reportState = true
      }
      // if(this.active2 == 1) {
      //   this.reportState = true
      // }
      this.shState = true; //审核状态
      this.cxState = true; //撤销审核状态
      this.backState = true; //退回状态
      this.saveState = true; //保存状态
      dataGrid({
        taskCode: this.sjtaskCode,
        ExeNo: this.sjExeno,
        StationCode: this.StationCode.slice(0, -1),
        StateId: this.stateId,
      }).then((result) => {
        let hbNum; //环比
        const res = result.dataList
        const columnMap = result.columnMapSet
        const arr = Object.keys(columnMap)
        arr.forEach(i=> {
          res.forEach(j=> {
            if(i == j.VarietyCode) {
              if(columnMap[i].itemNumbers) {
                j.itemNumbersShow = true
              }else {
                j.itemNumbersShow = false
              }
              if(columnMap[i].originBrand) {
                j.originBrandShow = true
              }else {
                j.originBrandShow = false
              }
            }
          })
        })
        for (let i = 0; i < res.length; i++) {
          this.taskName = res[i].taskName;
          this.stationName = res[i].stationname;

          let ringPrice = res[i].ringPrice; //上期 ringPrice
          let thisPrice = res[i].ThisPrice; //本期 ThisPrice
          if (res[i].ThisPrice == -1 || res[i].ThisPrice == "-") {
            res[i].ThisPrice = "";
          }
          if (!Number(ringPrice) || ringPrice == 0 || !Number(thisPrice)) {
            res[i].hbNum = "-";
            continue;
          }
          ringPrice = parseFloat(ringPrice);
          thisPrice = parseFloat(thisPrice);
          hbNum = ((thisPrice - ringPrice) / ringPrice) * 100;
          if (hbNum == Infinity || isNaN(hbNum)) {
            res[i].hbNum = "-";
          } else {
            if (
              hbNum.toString().indexOf(".") != -1 &&
              hbNum.toString().split(".")[1].length > 2
            ) {
              hbNum = hbNum.toFixed(2);
            }
            if (parseInt(hbNum) > 0) {
              res[i].styleColor = "red";
              res[i].HB = "<span style='color:red'>涨" + hbNum + "<span>";
            } else if (parseInt(hbNum) < 0) {
              res[i].styleColor = "green";
              res[i].HB = "<span style='color:green'>跌" + hbNum + "<span>";
            } else {
              res[i].styleColor = "black";
              res[i].HB = hbNum;
            }
            res[i].hbNum = hbNum;
          }
        }
        this.list = res;
        // this.listOld=res
        this.oldList = JSON.parse(JSON.stringify(res));
        // this.oldList=res;
        loading(false);
      });
    },
    //环比实时变化
    changePrice(i) {
      let hbNum;
      let ringPrice = this.list[i].ringPrice; //上期 ringPrice
      let thisPrice = this.list[i].ThisPrice; //本期 ThisPrice
      //report_digits
      if (!Number(thisPrice) || thisPrice == "") {
        this.list[i].hbNum = "-";
        return;
      }
      if (thisPrice.split(".").length - 1 > 1) {
        Toast("本期价格输入格式不正确请重新输入!");
        return;
      }
      thisPrice = parseFloat(thisPrice).toFixed(this.list[i].report_digits);
      this.list[i].ThisPrice = thisPrice;
      if (!Number(ringPrice) || ringPrice == 0) {
        this.list[i].hbNum = "-";
        return;
      }
      ringPrice = parseFloat(ringPrice);
      thisPrice = parseFloat(thisPrice);
      hbNum = ((thisPrice - ringPrice) / ringPrice) * 100;
      if (hbNum == Infinity || isNaN(hbNum)) {
        this.list[i].hbNum = "-";
      } else {
        if (hbNum > 0) {
          this.list[i].styleColor = "red";
        } else if (hbNum < 0) {
          this.list[i].styleColor = "green";
        } else {
          this.list[i].styleColor = "black";
        }
        if (
          hbNum.toString().indexOf(".") != -1 &&
          hbNum.toString().split(".")[1].length > 2
        ) {
          hbNum = hbNum.toFixed(2);
        }
        this.list[i].hbNum = hbNum;
      }
    },

    onClickLeft() {
      //   this.$router.go(-1)
      this.$router.push({
        path: "/cityReport/cityReport",
        query: {
          active2: this.active2,
        },
      });
    },
    // 点击导航栏右侧下一条按钮
    // onClickRight(){},
    onLoad() {
      //初始化table
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        this.finished = true;
      }, 1000);
    },
    //获取新的stationList
    ifStation(stationCode, stateId) {
      //code=>stationId,value=>stateId
      this.stationList.forEach((item) => {
        if (item.value == stationCode) {
          item.stateId = stateId;
        }
      });
    },
    // 点击商品名
    clickStoreName(item, index) {
      this.shopIndex1 = index + 1;
      //   this.shopName = item.VarietyName + '(' + item.StandardName + ')' //商品
      this.shopName =
        item.VarietyName + "--" + item.StandardName + "--" + item.TargetName; //商品
      this.bqPrice = item.ThisPrice; //本期价格
      this.bqPriceSave = item.ThisPrice
      this.isGoods = item.isGoods == 1 ? true : false
      this.contentSave = item.Memo; //说明
      this.brand = item.brand; //品牌
      this.ifShow = item.bring_previous_remark; //为0的时候不显示 品牌文本框,1显示
      this.content = item.Memo; //说明
      this.comments = item.comments;
      this.shopIndex = index;
      this.itemNumbersShow = item.itemNumbersShow
      this.originBrandShow = item.originBrandShow
      this.itemNumbers = item.itemNumbers ? item.itemNumbers : ''
      this.originBrand = item.originBrand ? item.originBrand : ''
      this.showDetial = true;
    },
    // 关闭弹框
    closeBasic() {
      this.showDetial = false;
    },
    //保存弹框信息
    saveBasic() {
      if (this.bqPrice > 99999999) {
        this.bqPrice = 99999999;
      } else if (this.bqPrice < 0) {
        this.bqPrice = 0;
      }
      this.list[this.shopIndex].ThisPrice = this.bqPrice; //本期价格
      this.list[this.shopIndex].brand = this.brand; //品牌brand
      this.list[this.shopIndex].Memo = this.content;//说明
      this.list[this.shopIndex].comments = this.comments; //备注
      this.list[this.shopIndex].isGoods = this.isGoods?1:0; //无此品种
      this.changePrice(this.shopIndex);
      if(this.originBrandShow) {
        this.list[this.shopIndex].originBrand = this.originBrand //品牌产地
      }
      if(this.itemNumbersShow) {
        this.list[this.shopIndex].itemNumbers = this.itemNumbers //数量
      }
      this.showDetial = false;
    },
    changeIsGoods() {
      if(this.isGoods == true) {
        this.bqPriceSave = this.bqPrice
        this.bqPrice = 0.00
        this.contentSave = this.content
        this.content = '无此品种'
      }else {
        this.bqPrice = this.bqPriceSave
        this.content = this.contentSave == '无此品种' ? '' : this.contentSave
      }
    },
    // 查看日志按钮
    chaKanRiZhi() {
      this.showLog = true;
      loading(true)
      this.getDateRecord();
    },
    //查看日志
    getDateRecord() {
      getDateRecord({
        taskId: this.dayTaskId,
        exeNo: this.sjExeno,
        stationCode: this.StationCode.slice(0, -1),
      }).then((res) => {
        this.logList = res;
        loading(false)
      });
    },
    report() {
      this.$dialog
        .confirm({
          message: "是否确认上报此条数据?",
        })
        .then(() => {
          loading(true)
          reportUpOk({
            exeno: this.exeNo,
            taskCode: this.taskCode,
            listPoint: this.StationCode.slice(0, -1),
            nationExeno: this.periodNumber,
            taskId: this.taskId
          }).then((res) => {
            if(res.code == 200) {
              Toast.success(res.message)
              this.reportState = true
            }else {
              Toast.fail(res.message)
            }
            this.getStationList2()
          });
        })
        .catch(() => {});
    },
    getStationList2() {
      getJgjcReportExamStation({
        exeno: this.periodSJNumber?this.periodSJNumber:this.sjExeno,
        pageIndex: 1,
        pageSize: 1000,
        taskCode: this.sjtaskCode,
        state:'',
        nationExeno:this.periodNumber
      }).then((res) => {
        res.data.list.forEach((i,j)=> {
          i.value = i.stationCode + j
          i.text = i.gjStationName
        })
        this.stationList = res.data.list
        this.stationList.forEach((item) => {
          if (item.value == this.StationCode) {
            this.gjstateName = item.gjstateName
            this.gjstate = item.gjstate
            this.stateName = item.stateName
            this.stateId = item.stateId
          }
        });
        loading(false)
      });
    },
    //监测登陆状态 houcc 2021.07.24
    checkLogin() {
      checkLogin({}).then((res) => {
        if (!res.success) {
          // nativeJSBridge.logout();
          this.$router.push({ path: "/loginOld" });
        }
        this.loginStatus = res.success;
      });
    },
    //判断是否复核判断条件 if(!this.ifCheckSaveRow()) return;
    ifCheckSaveRow() {
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (
          this.ifNullOrEmpty(item.Memo,0) &&
          ((item.ThisPrice == 0 && item.ThisPrice != "") || (item.hbzks !== null&& item.hbNum > item.hbzks && item.hbNum > 0) || (item.hbjks !== null && Math.abs(item.hbNum) > item.hbjks && item.hbNum < 0))
        ) {
          Toast("数据" + item.VarietyName + "请填写波动原因说明!");
          this.clickStoreName(this.list[i], i);
          return false;
        }
        if(item.ThisPrice && item.originBrandShow && !item.originBrand && !item.isGoods) {
          this.clickStoreName(this.list[i], i)
          Toast("数据"+item.VarietyName+"请填写品牌产地!")
          return false;
        }
        if(item.ThisPrice && item.itemNumbersShow && !item.itemNumbers && !item.isGoods) {
          this.clickStoreName(this.list[i], i)
          Toast("数据"+item.VarietyName+"请填写数量!")
          return false;
        }
      }
      return true;
    },
    ifCheckUpOk() {
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (item.ThisPrice == "") {
          Toast("本期价格不可为空!");
          this.clickStoreName(this.list[i], i);
          return false;
        }
        if (this.ifNullOrEmpty(item.Memo,1)) {
            Toast("数据"+item.VarietyName+"说明的字数不能太少，至少2个文字!")
            this.clickStoreName(this.list[i], i);
            return false;
        }
        if (this.ifNullOrEmpty(item.Memo,0)&& (item.ThisPrice == 0 || (item.hbzks !== null&& item.hbNum > item.hbzks && item.hbNum > 0) || (item.hbjks !== null && Math.abs(item.hbNum) > item.hbjks && item.hbNum < 0))) {
          Toast("数据" + item.VarietyName + "请填写波动原因说明!");
          this.clickStoreName(this.list[i], i);
          return false;
        }
        if(item.ThisPrice && item.originBrandShow && !item.originBrand && !item.isGoods) {
          this.clickStoreName(this.list[i], i)
          Toast("数据"+item.VarietyName+"请填写品牌产地!")
          return false;
        }
        if(item.ThisPrice && item.itemNumbersShow && !item.itemNumbers && !item.isGoods) {
          this.clickStoreName(this.list[i], i)
          Toast("数据"+item.VarietyName+"请填写数量!")
          return false;
        }
      }
      return true;
    },
    ifNullOrEmpty(obj,type) {
      var regu = "^[ ]+$";
      var re = new RegExp(regu);
      if (type==0 &&  (typeof obj == "undefined" || obj == null || obj == "" || re.test(obj))
      ) {
        return true;
      }else if( !(typeof obj == "undefined" || obj == null || obj == "" || re.test(obj)) && obj.length<2 && type==1 ){
        return true;
      } else {
        return false;
      }
    },
    // 点击下一条监测地点
    nextStation() {
      // if(!this.compareArray(this.list, this.oldList)) {
      //   await this.save();
      // }
      this.ifUpdateStation();
    },
    //判断是否改变了值
    ifUpdateStation(){
      //判断是否修改了审核数据
      for (let i = 0; i < this.stationList.length; i++) {
        if (this.StationCode === this.stationList[i].value) {
          if (i + 1 < this.stationList.length) {
            this.StationCode = this.stationList[i + 1].value;
            this.shopId = this.stationList[i + 1].shopId;
            this.stateId = this.stationList[i + 1].stateId;
            this.gjstate = this.stationList[i + 1].gjstate
            this.gjstateName = this.stationList[i + 1].gjstateName
            this.stateName = this.stationList[i + 1].stateName
            this.stateId = this.stationList[i + 1].stateId
            this.dayTaskId = this.stationList[i + 1].dayTaskId
            this.exeNo = this.stationList[i + 1].exeNo
            this.taskCode = this.stationList[i + 1].taskCode
            // this.dataGrid()
            this.isOpen = true;
            this.dataGrid(this.StationCode);
          } else {
            this.StationCode = this.stationList[0].value;
            this.shopId = this.stationList[0].shopId;
            this.stateId = this.stationList[0].stateId;
            this.gjstate = this.stationList[0].gjstate
            this.gjstateName = this.stationList[0].gjstateName
            this.stateId = this.stationList[0].stateId
            this.stateName = this.stationList[0].stateName
            this.dayTaskId = this.stationList[0].dayTaskId
            this.exeNo = this.stationList[0].exeNo
            this.taskCode = this.stationList[0].taskCode
            // this.dataGrid()
            this.isOpen = true;
            this.dataGrid(this.StationCode);
          }
          break;
        }
      }
    },

  // watch:{
  // 	    list: {
  // 	      handler(newValue, oldValue) {
  //           if(JSON.stringify(newValue)!==JSON.stringify(this.list)) {
  //             this.listFlag=true
  //           }
  //           console.log(this.listFlag);
  // 	      },
  // 	      immediate: false,
  // 	      deep: true
  // 	    }
  // }
     },
};
</script>
<style lang="scss" scoped>
#jiageshenheNew {
  background: #f0f2f1;
  height: 100%;
  /deep/.van-nav-bar__text:active {
    background-color: transparent;
  }
  .xinxi {
    padding-left: 0.463rem;
    padding-top: 0.3rem;
    width: calc(100vw - 0.463rem);
    height: 3.5rem;
    background-color: #ffffff;
    font-size: px2rem(36);
    color: #4494f3;
    vertical-align: middle;
  }
  .table-red {
    color: red;
  }
  .table-green {
    color: green;
  }
  .blue-box {
    display: inline-block;
    width: 0.06rem;
    height: 0.26rem;
    margin-right: 0.09rem;
    background-color: #4494f3;
  }
  .boxTitle {
    height: 1rem;
    line-height: 1rem;
    background-color: #4494f3;
    color: #ffffff;
    font-size: px2rem(36);
  }
  .table {
    height: calc(100% - 5.7158rem);
    .input {
      display: inline-block;
      vertical-align: middle;
      //   height: 0.9rem;
      //   line-height: 0.9rem;
      width: 1.3rem;
      background-color: #fff;
      border: px2rem(1) solid #4494f3;
      input {
        margin: 0;
        border: 0;
        height: 0.8rem;
        vertical-align: middle;
        width: 1.3rem;
        outline: none;
        text-align: right;
      }
    }
    .even {
      display: flex;
      font-size: px2rem(36);
      background-color: #f2fbfe;
      color: #3e3e3e;
      /deep/.van-row {
        width: 100%;
        height: 50px;
      }
    }
    .odd {
      display: flex;
      font-size: px2rem(36);
      background-color: #e0f7ff;
      color: #3e3e3e;
      /deep/.van-row {
        width: 100%;
        height: 50px;
      }
    }
    .contentLimit {
      //表格内容商品列限制三行展示
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 1.2rem;
    background-color: #fff;
    .btn {
      display: inline-block;
      //   width: 2rem;
      width: 1.77rem;
      height: 1rem;
      line-height: 1rem;
      border-radius: 1rem;
      background-color: #3486e8;
      color: #ffffff;
      font-size: px2rem(45);
      text-align: center;
      vertical-align: middle;
    }
    .btn1 {
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      font-size: px2rem(45);
      color: #2c7fe2;
      font-weight: bold;
      font-family: "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
      width: 2rem;
      // border-right: 1px solid #ababab;
    }
    v-button.btn1::after {
        content: '';
        width: 0.02rem;
        height: 0.6rem;
        background: #ababab;
        position: absolute;
        right: 0;
    }
    v-button.btn2::after {
        content: '';
        width: 0rem;
        height: 0rem;
        // background: #ababab;
        // position: absolute;
        // right: 0;
    }
  }
  //审核过的事项 底部按钮变灰
  .bianhui {
    pointer-events: none;
    filter: grayscale(1);
    .btn1 {
      font-weight: 400;
      color: #ababab;
    }
  }
  .yincang {
    display: none;
  }
  .btn {
    display: inline-block;
    width: 2rem;
    height: 1rem;
    line-height: 1rem;
    border-radius: 1rem;
    background-color: #3486e8;
    color: #ffffff;
    font-size: px2rem(45);
    text-align: center;
    vertical-align: middle;
  }
  /deep/.van-field--disabled .van-field__label {
    color: #000;
  }
  /deep/.van-field__control:disabled {
    color: #000;
    font-weight: bold;
    -webkit-text-fill-color: #000;
  }
  /deep/ .van-field__label {
    color: #000;
  }
  /deep/.van-cell {
    padding: 5px 16px;
    line-height: 0.9rem !important;
  }
    /deep/.van-field__label {
      width: 1.2rem !important;
    }
    /deep/ .long-label .van-field__label {
    width: 1.5rem !important;

  }
  /deep/ .long-label2 .van-field__label {
    width: 1.8rem !important;
  }
  /deep/ .long-txt .van-field__label {
    width: 1.8rem !important;
    line-height: 0.5rem !important;
    margin-top: 0.2rem;
    margin-left: -0.23rem;
  }
  .goodIs {
    width: 1.9rem;
    font-size: 0.37037rem;
    line-height: 1.2rem;
    height: 1.2rem;
  }
  .g_disabled {
    /deep/.van-field__control:disabled {
      color: #c8c9cc!important;
      -webkit-text-fill-color: #c8c9cc!important;
    }
  }
  .logTable {
    height: calc(100% - 1rem);
    .no-con {
      color:#3e3e3e;
      font-size:px2rem(36);
      text-align:center;
      margin: 0 auto;
      padding: 2rem 0;
    }
  }
  .logTitle {
    width: 100%;
    padding: px2rem(10) 0;
    color: #000;
    font-size: px2rem(60);
    font-weight: bold;
    text-align: center;
  }
  .logText {
    width: 100%;
    padding: px2rem(10) 0;
    color: #000;
    font-size: px2rem(40);
    font-weight: bold;
    text-align: left;
  }
  .logBox {
    margin: px2rem(20) px2rem(15);
    padding: 0.1rem 0;
    padding-bottom: 0.35rem;
    background-color: #fff;
    font-size: px2rem(36);
    /deep/.van-row {
      margin-top: 0.15rem;
    }
    // border-radius: 25px;
  }
  .twoLine {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height:0.48rem;
    /deep/.van-button {
      padding: 0;
      margin: 0;
      height: 0.63333rem;
      line-height: 00.63333rem;
    }
  }
  .select {
    width: 100%;
    height: 0.55rem;
    /deep/.van-cell .van-icon {
      line-height: inherit !important;
    }
    /deep/.van-dropdown-menu__title {
      width: 100%;
    }
    /deep/.van-popup--top {
      top: 0;
      left: 24.5%;
      width: 53%;
    }
    /deep/.van-ellipsis {
      color: #4494f3;
      font-size: px2rem(36);
    }
  }
  .selectDiv {
    width: 5.25rem;
    border: 0.5px solid #bcbcbc;
    /deep/.van-dropdown-menu__title::after {
      position: absolute;
      top: 50%;
      right: 3%;
    }
    /deep/.van-dropdown-menu__bar {
      height: 0.55rem;
      width: 100%;
    }
    /deep/.van-dropdown-item__option--active {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    /deep/ .van-cell {
      padding: 0.05rem 0.15rem;
      line-height: 0.8rem !important;
      width: 7rem;
    }
  }
}
</style>